import { api as supervisingApi } from "../api";
import { SubmissionsResponse } from "./types";

export const submissionsApi = supervisingApi.injectEndpoints({
    endpoints: (build) => ({
        getSubmissions: build.query<SubmissionsResponse, number>({
            query: (id: number) => ({
                url: `api/v1/supervising/submissions/${id}`,
            }),
        }),
    }),
});

export const { useGetSubmissionsQuery } = submissionsApi;
